import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import Providers from "./Providers";
import ResetCSS from "./styles/ResetCSS";
import { ThemeProvider } from "styled-components";
import theme from "./styles/theme";
import { stabilizeInjectedEthereum } from "./utils/stabilizeInjectedEthereum";

declare const window: any;
stabilizeInjectedEthereum();
if ("ethereum" in window) {
  (window && (window.ethereum as any)).autoRefreshOnNetworkChange = false;
}

ReactDOM.render(
  <React.StrictMode>
    <Providers>
      <ThemeProvider theme={theme}>
        <ResetCSS />
        <App />
      </ThemeProvider>
    </Providers>
  </React.StrictMode>,
  document.getElementById("root1") as HTMLElement
);
// unwanted code for us as we are running on local machine 15/04/2025
// ReactDOM.render(
//   <React.StrictMode>
//     <Providers>
//       <ThemeProvider theme={theme}>
//         <ResetCSS />
//         <App />
//       </ThemeProvider>
//     </Providers>
//   </React.StrictMode>,
//   document.getElementById("root2") as HTMLElement
// );
